"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Generated by CoffeeScript 1.12.2
var Change_Avatar = void 0;

Change_Avatar = function () {
  function Change_Avatar() {
    var saveAvatar = function saveAvatar() {
      var $button = void 0;
      var $fakeFile = void 0;
      var $filename = void 0;
      var $this = void 0;
      var $val = void 0;
      var newVal = void 0;
      var valArray = void 0;
      $this = $("input#choose-input");
      $val = $this.val();
      valArray = $val.split("\\");
      newVal = valArray[valArray.length - 1];
      $button = $(".button-container");
      $filename = $(".filename");
      $fakeFile = $this.siblings(".file-holder");
      if (newVal !== "") {
        if ($fakeFile.length === 0) {
          $filename.html("<span class=\"file-holder\">File: " + newVal + "</span>");
        } else {
          $fakeFile.text(newVal);
        }
        $("button.ui_save.hidden").removeClass("hidden");
        $("button.file-wrapper").hide();
        return $(".file-wrapper .button, .file-wrapper #choose-input").addClass("hidden");
      }
      $(".button.file-wrapper.ui_upload").addClass("hidden");
      $(".file-wrapper input[type=file]").bind("change focus click", saveAvatar);
    };
    $(".button.file-wrapper.ui_upload").on("click", function (e) {
      saveAvatar();
    });
    $("#save-avatar").on("click", function (e) {
      return $(this).addClass("processing");
    });
  }

  return Change_Avatar;
}();

exports.default = Change_Avatar;